import type { ViewStyle } from 'react-native'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faCcVisa } from '@fortawesome/free-brands-svg-icons/faCcVisa'
import { faCcMastercard } from '@fortawesome/free-brands-svg-icons/faCcMastercard'
import { faCcAmex } from '@fortawesome/free-brands-svg-icons/faCcAmex'
import { faCcDinersClub } from '@fortawesome/free-brands-svg-icons/faCcDinersClub'
import { faCcDiscover } from '@fortawesome/free-brands-svg-icons/faCcDiscover'

export const CONTAINER_WIDTH = 1140

// position sticky/fixed e transition só existem no CSS (RN não tem) — a página
// é web-only, e os tipos do RN não aceitam esses valores, daí o cast.
export const ASIDE_STICKY_STYLE = {
  position: 'sticky',
  top: 24,
} as unknown as ViewStyle

export const MOBILE_BAR_STYLE = {
  position: 'fixed',
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 100,
} as unknown as ViewStyle

export const CARD_BRAND_ICONS: Record<string, IconDefinition> = {
  visa: faCcVisa,
  master: faCcMastercard,
  mastercard: faCcMastercard,
  american_express: faCcAmex,
  diners_club: faCcDinersClub,
  discover: faCcDiscover,
}
